import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import logo from '../image/logo_2.jpg';

const AnimatedLogo = () => {
  const logoRef = useRef(null);
  // quickTo gives sub-frame response — no new tween allocation per event
  const scaleQuick = useRef(null);

  useEffect(() => {
    const el = logoRef.current;

    // ── Mount reveal sequence ────────────────────────────────────────────
    const tl = gsap.timeline();
    tl.fromTo(
      el,
      { autoAlpha: 0, scale: 0.88 },
      { autoAlpha: 1, scale: 1, duration: 0.9, ease: 'expo.out' }
    );

    // ── Pre-wire quickTo for hover (avoids per-event gsap.to overhead) ──
    scaleQuick.current = gsap.quickTo(el, 'scale', {
      duration: 0.25,
      ease: 'power2.out',
    });

    return () => tl.kill();
  }, []);

  return (
    <img
      ref={logoRef}
      src={logo}
      alt="Aetrix Logic"
      className="h-16 w-16 object-contain cursor-pointer"
      style={{ opacity: 0 }} /* GSAP autoAlpha manages visibility */
      onMouseEnter={() => scaleQuick.current?.(1.08)}
      onMouseLeave={() => scaleQuick.current?.(1)}
    />
  );
};

export default AnimatedLogo;